import Modal from "react-bootstrap/Modal";
import React, { useEffect, useState } from "react";
import { FieldArray, Formik, getIn } from "formik";
import PlusIcon from "assets/admin_img/awesome-plus.svg";
import MinusIcon from "assets/admin_img/minus.svg";
import { Button } from "react-bootstrap";
import moment from "moment";
import MultiEmailSelect from "components/common/MultiEmailSelect";
import { shareModelSchema } from "validations/InspectionRequest";
import {shareCertifictaeAPICall} from "services/inspections"
import { toast } from "react-toastify";
import Loader from "components/common/Loader";
import { datetimeFormats } from "constants/constants";
export default function ShareModel(props) {
  const { data, handleCloseModel, shareModelVisible } = props;
  const [formLoader, setFormLoader] = useState(true);
  const [isLoading, setIsLoading] = useState(false)
  const [buttonLoader, setButtonLoader] = useState(false)

  useEffect(() => {
    setFormLoader(false);
  });
  

  const initialValuesFormik =  {
    emails : [],
    pdfLink : data?.customer_id ==
    data?.Inspection_machine?.user_id  || data?.document_transferred? data?.Inspection_machine?.certificate?.issue_certificate : data?.Inspection_machine?.certificate?.upload_certificate,
    // data?.Inspection_machine?.certificate?.issue_certificate,
    machine_id : data?.Inspection_machine?.id


  }
  const handleSubmit = (values) => {
    setButtonLoader(true)
    shareCertifictaeAPICall(values).then((res : any)=>{     
      toast.success(res.message)
      setButtonLoader(false)
      handleCloseModel()
    }).catch((err)=>{
      setButtonLoader(false)
      toast.success('Something went wrong please try again.')
      handleCloseModel()
    })
      
  };
  return (
    <div id="section">
      {formLoader ? (
        <Loader isLoading={isLoading}/>
      ) : (
        <Modal
          show={shareModelVisible}
          onHide={handleCloseModel}
          centered
          backdrop="static"
          dialogClassName="modal-1029w"
        >
          <Modal.Header closeButton className="">
            <Modal.Title className="fs-17 fw-semibold">
              Share Certificate 
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* {formLoader && <ApiLoader />} */}
            <div>
              <div className="">
                <div className="row">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-12">
                      

                       

                        <div className="row">
                          
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <label className="form-label  fs-13 fw-semibold">
                              Make : <span className="text-gray-ligth"> {data?.Inspection_machine?.make}</span> 
                            </label>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label  fs-13 fw-semibold">
                              Model No :<span className="text-gray-ligth">  {data?.Inspection_machine?.model_number} </span>
                            </label>
                          </div>
                         
                         
                        </div>
                       
                        <div className="row">
                          <div className="col-md-6">
                            <label className="form-label  fs-13 fw-semibold">
                              Serial No:  <span className="text-gray-ligth"> {data?.Inspection_machine?.serial_number}</span>
                            </label>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label  fs-13 fw-semibold">
                              Certificate No. :<span className="text-gray-ligth">  {data?.Inspection_machine?.certificate?.certificate_number ? data?.Inspection_machine?.certificate?.certificate_number :"N/A"}</span>
                            </label>
                          </div>
                          
                          
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <label className="form-label  fs-13 fw-semibold">
                              Issue Date :<span className="text-gray-ligth">   {moment(data?.Inspection_machine?.certificate?.issue_date).format(datetimeFormats.separatedDate)}</span>
                            </label>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label  fs-13 fw-semibold">
                              Inspection Type :<span className="text-gray-ligth text-capitalize" >  {data?.Inspection_machine?.inspection_type} </span>
                            </label>
                          </div>
                          
                         
                        </div>
                      
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
              <Formik
          validationSchema={shareModelSchema}
          initialValues={initialValuesFormik}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            status,
          }) => (
            <div>
          <MultiEmailSelect  
                             controlId="emails"
                              value={values.emails}
                              label="User Email"
                              placeholder="Email Addresses"
                              disabled={!values.emails}
                              handleChange={handleChange}
                              errorsField={errors.emails}
                              setFieldValue={setFieldValue}
                              handleBlur={handleBlur}
                              touched={touched.emails}
                              /> 


  
<div className="alert alert-primary">Press the "Enter" key or use the space bar to add more email addresses.</div>

              

              <div className="d-flex  row mt-3">
               
                <div className="col-md-12">
                  <button
                    onClick={(e)=>{handleSubmit()}}
                    className="btn btn-primary black-color submitBtn mr-5"
                    type="button"
                  >
                    Share Certificate
                  </button>
                  &nbsp; &nbsp;
                  <button
                    className="fw-semibold  btn btn-secondary ml-3"
                    onClick={handleCloseModel}
                  >
                    Cancel
                  </button>
                </div>
              </div>

            </div>

          )}
          </Formik>

             
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
}
